import { Component, Input, SimpleChanges } from '@angular/core';
import { ProjectViewModel } from '../../../models-views/project.view.model';
import { defaultEventImage } from '../../../appCommon';

@Component({
  selector: 'app-cpd-events',
  standalone: false,
  templateUrl: './cpd-events.component.html',
  styleUrl: './cpd-events.component.scss'
})
export class CpdEventsComponent {
  @Input('project_id') project_id: any;

  events: any[] = [];
  loading = true;
  defaultEventImage = defaultEventImage;

  constructor(private vmp: ProjectViewModel) {
    this.vmp.projectEventResponseModel.subscribe((data: any) => {
      this.events = data?.results || [];
      this.loading = false;
    });
  }

  ngOnInit(): void {
    if (this.project_id) {
      this.fetchEvents();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['project_id'] && changes['project_id'].currentValue) {
      this.fetchEvents();
    }
  }

  fetchEvents() {
    this.loading = true;
    // Fetch recent events for the given project
    this.vmp.getEventsByProject(1, 10, this.project_id);
  }

  formatIdToFourDigits(id: number): string {
    // Mirror event-list: EV + 5 digits
    return id ? 'EV' + id.toString().padStart(5, '0') : '';
  }

  getBase64Image(data: string | undefined) {
    if (!data) {
      return undefined;
    }
    return 'data:image/png;base64,' + data;
  }

  getEventStatusColor(status: string): string {
    switch (status) {
      case 'Upcoming': return 'purple';
      case 'In Progress': return 'blue';
      case 'Cancelled': return 'red';
      case 'Completed': return 'green';
      default: return 'default';
    }
  }
}
